@if (!botConfig.hasImage || imageFailed) {
  <div
    class="bot-icon cursor-pointer m-auto "
    style=" width: 50px ;height: 50px;"
    [routerLink]="this.navigateOnClick() ? ['/','bot-admin', botConfig._id, botService.getBotDeeplink(botConfig)] : null"
    [ngStyle]="{
                    'background-color': botConfig.color,
                    'color': getContrastColor(botConfig.color),
                    'background-size': 'cover',
                  }"
    >
    <span>
      <i class="{{botConfig.icon}}"></i>
    </span>
  </div>
}
@if (botConfig.hasImage && !imageFailed) {
  <div
    class="bot-icon bot-image cursor-pointer m-auto"
    style=" width: 50px ;height: 50px;"
    [routerLink]="this.navigateOnClick() ?  ['/','bot-admin', botConfig._id, botService.getBotDeeplink(botConfig)] : null"
    >
    <img class="bot-thumbnail" alt="" width="50" height="50"
      [src]="'/api/toolbox/membot/public/botimg/' + botConfig._id + '/128' + (imageVersion() ? '?t=' + imageVersion() : '')"
      (error)="imageFailed = true">
  </div>
}
